import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { getContact } from '../api/contacts';

import { getUserFullName } from '../components/helpers/functions';
import Modal from '../components/Shell/Modal';
import { AvatarGenerated } from '../components/Avatar';
import Button from '../components/Button';
import LoadingSkeleton from '../components/Shell/LoadingSkeleton';

import useAsync from '../hooks/useAsync';
import useModal from '../hooks/useModal';

const MODAL_NAME = 'viewContact';

const getTitle = ({
	type = '',
	title = '',
	company = '',
	location = '',
} = {}) => {
	if (type === 'person') {
		if (company && title) {
			return `${title} at ${company.companyName}`;
		} else if (company && !title) {
			return `from ${company.companyName}`;
		} else if (!company && title) {
			return title;
		}
	} else if (type === 'company') {
		if (location) {
			return `${location && ` from ${location}`}`;
		}
		return null;
	}
	return null;
};

const ViewContactModal = () => {
	const navigate = useNavigate();
	const { open, setClose } = useModal(MODAL_NAME);

	const {
		value: contact,
		execute: refreshContact,
		status,
	} = useAsync(getContact, { immediate: false });

	useEffect(() => {
		if (open?.id) {
			refreshContact({ id: open?.id });
		}
	}, [open?.id]);

	return (
		<Modal open={open} key={MODAL_NAME} name={MODAL_NAME}>
			{status === 'pending' && !contact ? (
				<LoadingSkeleton />
			) : (
				<div>
					<div className="sm:flex items-center text-left">
						<div>
							<AvatarGenerated
								id={
									contact?.type === 'person'
										? getUserFullName(contact)
										: contact?.id
								}
								type={contact?.type}
							/>
							<div className="mt-4 font-semibold">
								{contact?.type === 'person'
									? getUserFullName(contact || {})
									: contact?.companyName}
							</div>
							<div className="text-gray-500 text-xs">
								{getTitle(contact || {})}
							</div>
						</div>
						<dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:ml-12 mt-4 sm:mt-0">
							{[
								{ label: 'Email', value: contact?.email },
								{ label: 'Phone Number', value: contact?.phoneNumber },
								contact?.type === 'person'
									? { label: 'Location', value: contact?.location }
									: {},
							]
								.filter(({ value }) => Boolean(value))
								.map((field) => (
									<div className="sm:col-span-1">
										<dt className="text-xs font-medium text-gray-500">
											{field?.label}
										</dt>
										<dd className="mt-1 text-sm text-gray-900">
											{field?.value}
										</dd>
									</div>
								))}
						</dl>
					</div>

					{!open?.disableFullProfile && (
						<div className="flex justify-end mt-8">
							<Button
								onClick={() => {
									setClose();

									if (typeof open?.onClose === 'function') {
										open.onClose();
									}

									navigate(`/manage/directory/${open?.id}`);
								}}
							>
								View Full Profile
							</Button>
						</div>
					)}
				</div>
			)}
		</Modal>
	);
};

export default ViewContactModal;
